import orderInstance from '../instance'

const processOrder = (order, processedBy) => {
	return orderInstance.put('/orders/' + (order) + '/process', { processedBy })
}

export default processOrder
